import { useSeo } from "../hooks/useSeo";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function CheckoutCancel() {
  useSeo({
    title: "Megszakított fizetés | Hair Elixir Hungary",
    description: "",
    noindex: true,
  });
  return (
    <main data-testid="page-checkout-cancel" className="pt-32 pb-32 he-container min-h-[60vh] text-center">
      <div className="max-w-xl mx-auto">
        <p className="overline mb-5">Megszakítva</p>
        <h1
          className="font-serif-display tracking-[-0.022em] leading-[1.06]"
          style={{ fontSize: "clamp(2.2rem, 5vw, 4rem)", fontWeight: 400 }}
        >
          A vásárlás <span className="italic text-[color:var(--he-gold)]">megszakítva.</span>
        </h1>
        <p className="mt-6 text-[color:var(--he-ink-soft)] font-light leading-[1.85]">
          Nem terheltünk meg semmit. A kosaradban a tételek megmaradtak — visszatérhetsz, és
          bármikor folytathatod a fizetést.
        </p>
        <Link
          to="/penztar"
          className="mt-10 inline-flex btn-outline-gold"
          data-testid="cancel-back-to-cart"
        >
          <ArrowLeft size={14} />
          <span>Vissza a kosárhoz</span>
        </Link>
      </div>
    </main>
  );
}
